(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cgc-language-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'cgc-language';
    const read = () => {
      try { return localStorage.getItem(KEY); } catch (error) { return null; }
    };
    const remember = (code) => {
      try { localStorage.setItem(KEY, code); } catch (error) { /* stockage indisponible */ }
    };

    // Retenir le choix fait avec le sélecteur de langue ou le bandeau.
    document.addEventListener('submit', (event) => {
      const button = event.submitter;
      if (button?.name === 'language_code') remember(button.value);
    });

    const banner = document.querySelector('[data-language-banner]');
    if (!banner) return;
    const current = banner.dataset.current;
    const options = [...banner.querySelectorAll('[data-language-option]')];
    const offered = [current, ...options.map((option) => option.dataset.languageOption)];

    let wanted = read();
    if (!wanted) {
      const browser = (navigator.languages?.length ? navigator.languages : [navigator.language || ''])
        .map((tag) => tag.slice(0, 2).toLowerCase());
      wanted = browser.find((code) => offered.includes(code)) || (browser[0] ? 'en' : null);
    }
    if (!wanted || wanted === current) return;

    const option = options.find((item) => item.dataset.languageOption === wanted);
    if (!option) return;
    option.hidden = false;
    banner.hidden = false;
    option.querySelector('[data-language-stay]').addEventListener('click', () => {
      remember(current);
      banner.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cgc-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.cgcLocalizationKeys) return;
    window.cgcLocalizationKeys = true;

    const optionsOf = (disclosure) => [...disclosure.querySelectorAll('.localization__option')];

    document.addEventListener('keydown', (event) => {
      const disclosure = event.target.closest?.('[data-localization] details');
      if (!disclosure) return;
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      const options = optionsOf(disclosure);
      if (!options.length) return;
      const onSummary = event.target.matches('summary');

      if (onSummary) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        disclosure.open = true;
        const current = options.find((option) => option.getAttribute('aria-current') === 'true');
        (current || options[0]).focus();
        return;
      }

      const index = options.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'ArrowDown') next = (index + 1) % options.length;
      if (event.key === 'ArrowUp') next = (index - 1 + options.length) % options.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = options.length - 1;
      options[next].focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cgc-store-hours"] && !Shopify.designMode) return;
  try {
    (() => {
    let today;
    try {
      const name = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'Europe/Paris' }).format(new Date());
      today = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(name);
    } catch (error) {
      today = new Date().getDay();
    }
    document.querySelectorAll('[data-store-hours] [data-day]').forEach((row) => {
      if (Number(row.dataset.day) !== today) return;
      row.classList.add('is-today');
      row.querySelector('.store-hours__today')?.removeAttribute('hidden');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
